import Routes from './graphs.router';
import options from './graphs.component';

const Component = {
    selector: 'dtGraphs',
    options
};

export {
    Component,
    Routes
};



// WEBPACK FOOTER //
// ./app/components/sensors-and-connectors/graphs/index.js